/**
 * TypeScript representation of the WarehouseHandlingTier enum in String Array format
 * from the Java class com.amazon.warehouseHandlingTiers.WarehouseHandlingTier
 */
// Country-specific WHT arrays
export const IN_WHTS: string[] = [
  'std-in-10k', 'exp-in-grd-cod-eligible', 'same-in-cod-eligible',
  'std-in-50k', 'std-sns-in', 'std-in-buyback-cod-eligible',
  'exp-in-cod-eligible', 'std-in-buyback', 'exp-in',
  'same-in-am', 'exp-in-store', 'Default'
];

export const DEFAULT_WHTS: string[] = [
  'Default', 'pa-expedited', 'expedited', 'rapid', 'rush', 'next'
];

// Default WHT constant (replaces WarehouseHandlingTier.Default)
export const DEFAULT_WHT = 'Default';

// All known WHTs across all countries
export const ALL_WHTS: string[] = DEFAULT_WHTS.concat(IN_WHTS.filter(t => DEFAULT_WHTS.indexOf(t) === -1));

/**
 * Get valid WHTs for a country code
 */
export const getValidWHTsForCountry = (countryCode: string | null | undefined): string[] => {
  return countryCode === 'IN' ? IN_WHTS : DEFAULT_WHTS;
};
